/**
 * Maps new language codes to legacy codes (en_US, es_MX)
 * Used for backwards compatibility with tiers created before the language code migration
 */
export const getLegacyLanguageCode = (languageCode) => {
  if (!languageCode) return null;

  // English variants -> en_US
  if (languageCode.startsWith('en')) {
    return 'en_US';
  }

  // Any Spanish variant (except es_MX which stays as is) -> es_MX
  if (languageCode.startsWith('es')) {
    return 'es_MX';
  }

  // All other languages (Chinese, Arabic, etc.) -> es_MX as fallback
  return 'es_MX';
};

/**
 * Gets content with automatic fallback to legacy language codes
 * @param {Object} allContent - All content object (content from form)
 * @param {string} languageCode - Target language code (e.g., 'es_AR', 'zh_AR')
 * @returns {Object|null} Content for the language, or null if not found
 */
export const getContentWithFallback = (allContent, languageCode) => {
  if (!allContent || !languageCode) return null;

  // Try direct match first
  if (allContent[languageCode]) {
    return allContent[languageCode];
  }

  // Try legacy fallback
  const legacyCode = getLegacyLanguageCode(languageCode);
  if (legacyCode && allContent[legacyCode]) {
    return allContent[legacyCode];
  }

  return null;
};
